import { useViewCountAndStatus } from 'find-and-filter-data/view-counts-and-unread/public';
import { isProcessing } from 'find-and-filter-data/views-schema/public';
import { Text } from 'foundations-components/components/Text';
import { jsx as _jsx } from "react/jsx-runtime";
const ViewCount = ({
  view
}) => {
  const {
    count,
    hasUnread
  } = useViewCountAndStatus(view);
  if (count === null || isProcessing(view)) {
    return null;
  }
  return /*#__PURE__*/_jsx(Text, {
    "data-test-vr-hidden": true,
    typography: hasUnread ? 'heading-50' : 'body-100',
    children: count
  });
};
ViewCount.displayName = 'ViewCount';
export default ViewCount;